import { Stack } from '@mui/material'
import { Box } from '@mui/system'
import { observer } from 'mobx-react-lite'
import moment from 'moment'
import React, { useState } from 'react'
import DataUnit from '../../../../../components/customElements/DataUnit/DataUnit'
import CustomAccordion from '../../../../../components/customElements/RequestDataAccordions/utils/CustomAccordion'
import { getImageSrc } from '../../../../../helpers/getImageSrc'
import { isOperator } from '../../../../../services/AccountService'
import { getComp } from '../../../../../utils/utils/DI'
import { createServiceRequestStore } from '../../NewDrawers/stores/NewCreateServiceRequestStore'
const ServiceRequestDrawerElement = ({ el, leftIcon, customOpen }) => {
  const [openedAccordionIndex, setOpenedAccordionIndex] = useState(-1)
  const statusStore = getComp('StatusesStore')
  const { searchParams } = createServiceRequestStore

  function formatPhoneNumber(phoneNumber) {
    const cleaned = ('' + phoneNumber).replace(/\D/g, '')
    const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})$/)

    if (match) {
      return `+${match[1]} (${match[2]})-${match[3]}-${match[4]}-${match[5]}`
    }

    return null // Вернуть null, если входные данные некорректны
  }

  return (
    <CustomAccordion
      summary={
        <Stack direction={'row'} gap={'6px'} alignItems={'center'}>
          <img
            src={statusStore.getServiceOrderStatusImage(el.status)}
            alt={statusStore.getServiceOrderStatusName(el.status)}
          />
          Заявка на {!isOperator() ? 'обслуживание' : 'ремонт'} № {el.id}
        </Stack>
      }
      key={el.orderId}
      headColor={'rgba(246, 246, 246, 1)'}
      contentPadding={'9px 0'}
      leftIcon
      orderId={el.orderId}
      arrowIcon={<img src={getImageSrc('shevronRight')} />}
      openedAccordionIndex={openedAccordionIndex}
      setOpenedAccordionIndex={setOpenedAccordionIndex}
      index={0}
      setChecked={() => {}}
    >
      <Box
        sx={{
          padding: '10px 0 0 40px',
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
        }}
      >
        <DataUnit
          name='Дата создания'
          value={el.created ? moment(el.created).format('DD.MM.YYYY') : '-'}
        />
        <DataUnit
          name='Заказчик'
          value={`${el.surname || ''} ${el.name || ''} ${el.patronymic || ''}`}
        />
        <DataUnit name='Телефон' value={formatPhoneNumber(el.phoneNumber)} />
        <DataUnit name='Тип инцидента' value={el?.incidentType ?? '-'} />
        <DataUnit name='Со слов абонента' value={el?.malfunctionType ?? '-'} />
        <DataUnit name='Дополнительная информация' value={el.additionalInfo} />
      </Box>
    </CustomAccordion>
  )
}

export default observer(ServiceRequestDrawerElement)
